module.exports = __webpack_public_path__ + "static/media/frax.ea037627.png";